<svelte:options accessors/>
<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import NauiTable from "../../naui/components/NauiTable.svelte";
    import type {ITableField} from "../../interfaces";
    import NauiDateRange from "../../naui/atoms/NauiDateRange.svelte";

    export let data: Array<IPagoHistorico>;
    export let columns: Array<ITableField>;
    export let urlHistorico: string;

    let filtered = data;
    let dateFilter = null;

    interface IPagoHistorico {
        fecha: string;
        referencia: string;
        valor: number;
        comprobante: string;
    }

    function filterData(ev) {
        if (ev.detail) {
            const dts = ev.detail.split(' - ');
            const min = new Date(dts[0]).getTime();
            const max = new Date(dts[1]).getTime();

            filtered = filtered.filter(d => {
                const splitDate = d.fecha.split('/');
                const ven = new Date(`${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`).getTime();
                return ven >= min && ven <= max;
            });
        }
    }

    function clear() {
        dateFilter = null;
        filtered = data;
    }

</script>
<section class="max-w-900px">
    <div class="box-b mb-15 m:block">
        <div class="box-l sx-ii m:mb-1">
            <NauiDateRange bind:value={dateFilter} on:change={filterData}/>
            <div class="pt-i">
                <NauiButton icon="refresh" color="secondary" on:click={clear}/>
            </div>
        </div>
        <NauiButton caption="DESCARGAR REPORTE" size="small" mode="stroked" href={urlHistorico}/>
    </div>
    <NauiTable {columns} data={filtered}/>
</section>